import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SharedModule } from '../shared.module';

@Component({
  selector: 'app-privacy-policy',
  imports: [SharedModule],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
})
export class PrivacyPolicyComponent {
  dialogRef = inject(MatDialogRef<PrivacyPolicyComponent>, { optional: true });
  data = inject(MAT_DIALOG_DATA, { optional: true });

  mode: 'dialog' | 'normal' = this.data?.mode ?? 'normal';

  onAgreed(): void {
    if (this.mode === 'dialog' && this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
